"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolEchainMath = void 0;
/**
 * Formulas related to RolEchain Ketten
 *
 * Documentation and further resources can be found at:
 * https://igusdev.atlassian.net/wiki/spaces/EKE10/pages/3968926068/Rol-echain
 */
class RolEchainMath {
    /**
     * Calculates the length of a RolEchain Part.
     */
    static calcPartLength_mm(cumulatedNumLinksKG, cumulatedNumLinksRKG, cumulatedNumLinksAKG, teilungKG_mm, teilungRKG_mm) {
        return (cumulatedNumLinksKG * teilungKG_mm + cumulatedNumLinksRKG * teilungRKG_mm + cumulatedNumLinksAKG * teilungKG_mm);
    }
    /**
     * Calculates the amount of RolEchain Part repetitions (Anzahl der Teilstücke).
     * Used to calc the amounts for Part2 and Part3.
     */
    static calcPartAmount(lengthTheo_mm, lengthPart1_mm, lengthPart2_mm, lengthPart3_mm) {
        return Math.floor((lengthTheo_mm - lengthPart1_mm) / (lengthPart2_mm + lengthPart3_mm));
    }
    /**
     * Calculates the amount of RolEchain Part repetitions by formula #2 (Anzahl der Teilstücke).
     * This formula is optimized for certain P4 Ketten, so they do not start with a RolLink.
     * Used to calc the amounts for Part2 and Part3.
     */
    static calcPartAmountFormula2(lengthTheo_mm, lengthPart1_mm, lengthPart2_mm, lengthPart3_mm) {
        return Math.floor((lengthTheo_mm - lengthPart1_mm - lengthPart2_mm) / (lengthPart2_mm + lengthPart3_mm));
    }
    /**
     * Calculates the amount of KG links in PartFP.
     */
    static calcNumLinksForPartFP(lengthTheo_mm, lengthPart1_mm, lengthPart2_mm, lengthPart3_mm, amountPart2Repetitions, teilungKG_mm) {
        return Math.ceil((lengthTheo_mm - amountPart2Repetitions * (lengthPart2_mm + lengthPart3_mm) - lengthPart1_mm) / teilungKG_mm);
    }
    /**
     * Calculates the length in mm of a RolEchain kette without any AE.
     */
    static calcLengthWithoutAE_mm(lengthPart1_mm, lengthPart2_mm, lengthPart3_mm, amountPart2Repetitions, amountPart3Repetitions, amountPartFPRepetitions, teilungKG_mm) {
        return (lengthPart1_mm +
            lengthPart2_mm * amountPart2Repetitions +
            lengthPart3_mm * amountPart3Repetitions +
            amountPartFPRepetitions * teilungKG_mm);
    }
    /**
     * Calculates the total amount of RKG links for a RolEchain kette.
     */
    static calcNumLinksRKG(cumulatedNumLinksRKGPart1, numLinksRKGPart2, amountPart2Repetitions, numLinksRKGPart3, amountPart3Repetitions) {
        return (cumulatedNumLinksRKGPart1 + numLinksRKGPart2 * amountPart2Repetitions + numLinksRKGPart3 * amountPart3Repetitions);
    }
    /**
     * Calculates the total amount of AKG links for a RolEchain kette.
     */
    static calcNumLinksAKG(cumulatedNumLinksAKGPart1, numLinksAKGPart2, amountPart2Repetitions, numLinksAKGPart3, amountPart3Repetitions) {
        return (cumulatedNumLinksAKGPart1 + numLinksAKGPart2 * amountPart2Repetitions + numLinksAKGPart3 * amountPart3Repetitions);
    }
    /**
     * Calculates the total amount of KG links for a RolEchain kette.
     */
    static calcNumLinksKG(lengthWithoutAE_mm, totalNumLinksRKG, teilungRKG_mm, totalNumLinksAKG, teilungKG_mm, numFirstOtherLinks, numLinksKGVersatz) {
        return ((lengthWithoutAE_mm - totalNumLinksRKG * teilungRKG_mm - totalNumLinksAKG * teilungKG_mm) / teilungKG_mm -
            numFirstOtherLinks +
            numLinksKGVersatz);
    }
    /**
     * Calculates the total weight of a RolEchain in kg.
     */
    static calcTotalWeight_kg(numLinksKG, weightKG_g, numLinksRKG, weightRKG_g, numLinksAKG, weightAKG_g) {
        return (numLinksKG * weightKG_g + numLinksRKG * weightRKG_g + numLinksAKG * weightAKG_g) / 1000;
    }
    /**
     * Calculates the number of KG links for Versatz of a RolEchain
     */
    static calcNumKGForVersatz(versatz_mm, teilungStandardLink_mm) {
        // versatz_mm could be negative.
        const absoluteVersatz_mm = Math.abs(versatz_mm);
        return Math.ceil(absoluteVersatz_mm / teilungStandardLink_mm);
    }
}
exports.RolEchainMath = RolEchainMath;
//# sourceMappingURL=rol-echain-math.js.map